import { DocumentSearchIcon, TagIcon, DocumentAddIcon, DownloadIcon, SearchIcon } from "@heroicons/react/solid";

import { BUTTON_VARIANT_TYPES, NO_ACCESS_TYPES, PERMISSIONS } from "../../../../utils/constants";

import Button from "../../../SharedComponents/Button";
import Tippy from "@tippyjs/react";
import { useNavigate } from "react-router-dom";
import AccessControl from "../../../SharedComponents/AccessControl";

function ReportRow(props) {
    const { item: report, functionArray } = props;

    const navigate = useNavigate();

    let latestVersion = null;

    if (report?.documentVersions.length > 0)
        latestVersion = report?.documentVersions?.reduce((prev, current) =>
            prev.versionNumber > current.versionNumber ? prev : current
        );

    const handleGoToManageReport = () => {
        navigate("/reports/manage-report", {
            state: {
                reportIdentifier: report.identifier,
            },
        });
    };

    return (
        <tr
            key={report.EmailAddress}
            className={report.identifier === functionArray.uploadedReport ? "bg-green-50" : ""}
        >
            <td className="px-4 py-3 whitespace-nowrap">
                <div className={"flex flex-row gap-3 items-center"}>
                    <div className="text-sm font-medium text-blue-gray-600 uppercase">{report.name}</div>
                    {report.identifier === functionArray.uploadedReport && (
                        <span className={"bg-green-500 text-xs text-white rounded-full p-1 px-2"}>New!</span>
                    )}
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className="flex items-center">
                    <div>
                        <div className="text-sm font-medium text-blue-gray-600">{report.userName}</div>
                        <div className="text-sm text-blue-gray-500 mt-1">{report.userEmail}</div>
                    </div>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex justify-center"}>{latestVersion?.versionNumber ?? 0}</div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex gap-3 justify-center items-center"}>
                    {report.tags.length > 0 && (
                        <Tippy
                            content={<span>This document is protected by tagging</span>}
                            className={"p-2 shadow rounded-md bg-primary-100 text-primary-700 text-sm"}
                            arrow={false}
                            animation={"shift-away-subtle"}
                        >
                            <div className="cursor-pointer">
                                <TagIcon className="block h-4 w-4" />
                            </div>
                        </Tippy>
                    )}

                    <AccessControl
                        requiredPermission={PERMISSIONS.DOWNLOAD_ADDITIONAL_FILES}
                        noAccessType={NO_ACCESS_TYPES.BLANK}
                    >
                        {latestVersion?.subsequentFiles.length > 0 && (
                            <Tippy
                                content={
                                    <span>
                                        This document has {latestVersion.subsequentFiles.length} additional file
                                        {latestVersion.subsequentFiles.length > 1 ? "s" : ""}
                                    </span>
                                }
                                className={"p-2 shadow rounded-md bg-primary-100 text-primary-700 text-sm"}
                                arrow={false}
                                animation={"shift-away-subtle"}
                            >
                                <div className="cursor-pointer flex items-center text-xs bg-blue-gray-200 p-1 px-2 rounded-full">
                                    <DocumentAddIcon className="block h-4 w-4 mr-1" />x{" "}
                                    {latestVersion.subsequentFiles.length}
                                </div>
                            </Tippy>
                        )}
                    </AccessControl>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex flex-col gap-3 items-center"}>
                    {report.released ? (
                        <div className="text-xs font-medium text-blue-gray-500">
                            <span className={"text-blue-gray-600 bg-blue-gray-200 p-1 px-2 rounded-full"}>
                                2/4 reviewed
                            </span>
                        </div>
                    ) : (
                        <div className="text-xs font-medium text-blue-gray-500">
                            <span className={"text-secondary-50 bg-secondary-600 p-1 px-2 rounded-full"}>Released</span>
                        </div>
                    )}
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap">
                <div className={"flex flex-col gap-3"}>
                    <Button
                        onClick={() => handleGoToManageReport()}
                        iconPositionLeft
                        icon={<DocumentSearchIcon className="block h-4 w-4 mr-2" />}
                        colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                        text="Manage"
                        extraStyling="shadow-none text-primary-600 p-0 focus:ring-0 focus:transparent"
                    />
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex flex-row gap-3 items-center"}>
                    {latestVersion?.fileFormat === "JSON" || latestVersion?.fileFormat === "json" ? (
                        <Button
                            onClick={() =>
                                navigate("/report", {
                                    state: {
                                        userName: report.userName,
                                        reportName: report.name,
                                        reportIdentifier: report.identifier,
                                    },
                                })
                            }
                            iconPositionLeft
                            icon={<SearchIcon className="block h-3.5 w-3.5 mr-2" />}
                            colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                            text="View"
                            extraStyling="shadow-none text-primary-600 p-0 focus:ring-0 focus:transparent"
                        />
                    ) : (
                        <Button
                            onClick={() => functionArray.handleDownloadReport(report.identifier)}
                            iconPositionLeft
                            icon={<DownloadIcon className="block h-3.5 w-3.5 mr-2" />}
                            colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                            loading={functionArray.currentlyDownloading === report.identifier}
                            disabled={functionArray.currentlyDownloading}
                            text="Download"
                            extraStyling="shadow-none text-primary-600 p-0 focus:ring-0 focus:transparent"
                        />
                    )}
                </div>
            </td>
        </tr>
    );
}

export default ReportRow;
